/* eslint-disable @typescript-eslint/no-explicit-any */
import apiService from './api'
import { sanitizeQueryParams } from '../utility/helpers/apiHelper'
import type { TableSortValue } from "@src/shared/constants/sort-order.constants";


interface GetServicesParams {
  page?: number
  pageSize?: number
  search?: string
  status?: string
  categoryId?: number | null
  orderBy?: string
  orderDirection?: TableSortValue
  [key: string]: any
}

export class ServiceService {
  async getServices(query: GetServicesParams) {
    return apiService.get('/services', { params: sanitizeQueryParams(query) })
  }

  async getService(id: number) {
    return apiService.get(`/services/${id}`)
  }

  async updateServiceStatus(
    id: number,
    data: { status: string; rejectionReason?: string }
  ) {
    return apiService.patch(`/services/${id}/status`, data)
  }

  async updateServiceTags(id: number, data: { tags: string[] }) {
    return apiService.patch(`/services/${id}/tags`, data)
  }

  async updateServiceCategory(
    id: number,
    data: { categoryId: number | null }
  ) {
    return apiService.patch(`/services/${id}/category`, data)
  }

  async updateServiceSubCategories(
    id: number,
    data: { subCategoryIds: number[] }
  ) {
    return apiService.patch(`/services/${id}/subcategories`, data)
  }
}

export const serviceService = new ServiceService()
